import styles from './order-details.dialog.module.scss';
import { useTranslation } from "../../i18n/useTranslation";
import { default as globalStyles } from '../../global-styles.module.scss'
import classNames from 'classnames';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import OrdersDetailsInside from './orders-details-inside';
import { DialogTitle, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface IOrderDetailsDialog {
    isOpen: boolean;
    handleCloseDialog: Function;
    documentId: string, 
    documentNumber: string, 
    documentDate: Date, 
    documentStatusName: string | null,
    orderBondFileUuid: string | null
}

const OrderDetailsDialog: React.FC<IOrderDetailsDialog> = ({isOpen, handleCloseDialog, documentId, documentNumber, documentDate, documentStatusName, orderBondFileUuid}) => {
    const { t } = useTranslation('translation');
    
    const handleClose = () => {
        handleCloseDialog(false);
    };

    return (
        <Dialog
            open={isOpen}
            hideBackdrop={false}
            fullScreen={false}
            PaperProps={{style: { margin: 0, minWidth: `90%` } }}>
            <DialogTitle className={styles.title}>
                <div className={globalStyles.space_between_item}>
                    <label className={styles.h1}>{t('ORDER')}: {documentNumber}</label>
                    <Tooltip title={t('CLOSE')}>
                        <button
                            id = {'order-details-dialog-close-btn'}
                            className={classNames(globalStyles.default_button_style)}
                            onClick={() => {handleClose()}}>
                            <ClearIcon></ClearIcon>
                        </button>
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className={globalStyles.space_between_item}>
                    <section className={globalStyles.m_w_100}>
                        <OrdersDetailsInside documentId={documentId as string} documentNumber={documentNumber as string} documentDate={documentDate as Date} documentStatusName={documentStatusName as string | null} orderBondFileUuid={orderBondFileUuid as string | null}></OrdersDetailsInside>
                    </section>
                </div>
            </DialogContent>
        </Dialog>
    );
}
export default OrderDetailsDialog;
;